<template>
  <v-simple-table :dense="true" :fixed-header="true">
    <template v-slot:default>
      <thead></thead>
      <tbody>
        <template v-if="showHeader == true">
          <tr>
            <td class="text-xs-left" :width="width.toString() + '%'">
              <h3>{{ $t("advanced.headers." + unitName) }}</h3>
            </td>
          </tr>
        </template>

        <template v-if="filter.includes('UI') === true">
          <template v-if="unitName == 'inverter'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.soc')" :value="unitState.soc" unit="%" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.dod')" :value="unitState.dod" unit="%" :widthRatio="width"></AdvancedCore>
          </template>

          <template v-if="unitName == 'dab'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.dc.u')" :value="unitState.dc.u" unit="V" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.dc.i')" :value="unitState.dc.i" unit="A" :widthRatio="width"></AdvancedCore>
          </template>

          <template v-if="unitName == 'inverter'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.uDC')" :value="unitState.uDC" unit="V" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.iDC')" :value="unitState.iDC" unit="A" :widthRatio="width"></AdvancedCore>
          </template>

          <template v-if="unitName == 'dab'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.bat.u')" :value="unitState.bat.u" unit="V" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.bat.i')" :value="unitState.bat.i" unit="A" :widthRatio="width"></AdvancedCore>
          </template>
        </template>

        <template v-if="filter.includes('P') === true">
          <template v-if="unitName == 'inverter'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.powerDC')" :value="unitState.powerDC" unit="kW" :widthRatio="width"></AdvancedCore>
          </template>
        </template>
        <template v-if="filter.includes('E') === true">
          <template v-if="unitName == 'inverter'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.energyDC')" :value="unitState.energyDC" unit="kWh" :widthRatio="width"></AdvancedCore>
          </template>
        </template>
        <template v-if="filter.includes('UI') === true">
          <template v-if="unitName == 'pv' || unitName == 'mppt'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.uIn')" :value="unitState.uIn" unit="V" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.iIn')" :value="unitState.iIn" unit="A" :widthRatio="width"></AdvancedCore>
          </template>
        </template>
        <template v-if="filter.includes('P') === true">
          <template v-if="unitName == 'pv' || unitName == 'mppt'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.powerIn')" :value="unitState.powerIn" unit="kW" :widthRatio="width"></AdvancedCore>
          </template>

          <template v-if="unitName == 'dab'">
            <template v-if="'dc' in unitState">
              <AdvancedCore :name="$t('advanced.' + unitName + '.dc.power')" :value="unitState.dc.power" unit="kW" :widthRatio="width"></AdvancedCore>
            </template>
            <template v-if="'bat' in unitState">
              <AdvancedCore :name="$t('advanced.' + unitName + '.bat.power')" :value="unitState.bat.power" unit="kW" :widthRatio="width"></AdvancedCore>
            </template>
          </template>
        </template>
        <template v-if="filter.includes('E') === true">
          <template v-if="unitName == 'pv' || unitName == 'mppt'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.energyIn')" :value="unitState.energyIn" unit="kWh" :widthRatio="width"></AdvancedCore>
          </template>

          <template v-if="unitName == 'dab'">
            <template v-if="'dc' in unitState">
              <AdvancedCore :name="$t('advanced.' + unitName + '.dc.energy')" :value="unitState.dc.energy" unit="kWh" :widthRatio="width"></AdvancedCore>
            </template>

            <template v-if="'bat' in unitState">
              <AdvancedCore :name="$t('advanced.' + unitName + '.bat.energy')" :value="unitState.bat.energy" unit="kWh" :widthRatio="width"></AdvancedCore>
            </template>
          </template>
        </template>
        <template v-if="filter.includes('UI') === true">
          <template v-if="unitName == 'inverter' && unitName == 'grid'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.u')" :value="unitState.u" unit="V" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.i')" :value="unitState.i" unit="A" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.f')" :value="unitState.f" unit="Hz" :widthRatio="width"></AdvancedCore>
          </template>

          <!-- <AdvancedCore :name="$t('advanced.' + unitName + '.phase')" :value="unitState.phase" unit="°"></AdvancedCore> -->
          <!-- <AdvancedCore :name="$t('advanced.' + unitName + '.phi')" :value="unitState.phi" unit="°"></AdvancedCore> -->
        </template>

        <template v-if="filter.includes('E') === true">
          <template v-if="unitName == 'inverter' || unitName == 'grid'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.energy')" :value="unitState.energy" unit="kWh" :widthRatio="width"></AdvancedCore>
          </template>
        </template>
        <template v-if="filter.includes('P') === true">
          <template v-if="unitName == 'grid'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.activePower')" :value="unitState.activePower" unit="kW" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.reactivePower')" :value="unitState.reactivePower" unit="kVAr" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.apparentPower')" :value="unitState.apparentPower" unit="kVA" :widthRatio="width"></AdvancedCore>
          </template>
        </template>

        <template v-if="filter.includes('UI') === true">
          <template v-if="unitName == 'inverter'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.u1')" :value="unitState.u1" unit="V" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.u2')" :value="unitState.u2" unit="V" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.u3')" :value="unitState.u3" unit="V" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.i1')" :value="unitState.i1" unit="A" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.i2')" :value="unitState.i2" unit="A" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.i3')" :value="unitState.i3" unit="A" :widthRatio="width"></AdvancedCore>
          </template>
        </template>

        <template v-if="filter.includes('P') === true">
          <template v-if="unitName == 'inverter'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.p1')" :value="unitState.p1" unit="kW" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.p2')" :value="unitState.p2" unit="kW" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.p3')" :value="unitState.p3" unit="kW" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.activePower')" :value="unitState.activePower" unit="kW" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.power')" :value="unitState.power" unit="kW" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.q1')" :value="unitState.q1" unit="kVAr" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.q2')" :value="unitState.q3" unit="kVAr" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.q3')" :value="unitState.q3" unit="kVAr" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.reactivePower')" :value="unitState.reactivePower" unit="kVAr" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.s1')" :value="unitState.s1" unit="kVA" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.s2')" :value="unitState.s3" unit="kVA" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.s3')" :value="unitState.s3" unit="kVA" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.apparentPower')" :value="unitState.apparentPower" unit="kVA" :widthRatio="width"></AdvancedCore>
          </template>
        </template>

        <template v-if="filter.includes('UI') === true">
          <template v-if="unitName == 'grid'">
            <template v-if="'internal' in unitState">
              <AdvancedCore :name="$t('advanced.' + unitName + '.internal.u1')" :value="unitState.internal.u1" unit="V" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.internal.u2')" :value="unitState.internal.u2" unit="V" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.internal.u3')" :value="unitState.internal.u3" unit="V" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.internal.i1')" :value="unitState.internal.i1" unit="A" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.internal.i2')" :value="unitState.internal.i2" unit="A" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.internal.i3')" :value="unitState.internal.i3" unit="A" :widthRatio="width"></AdvancedCore>
            </template>
          </template>
        </template>

        <template v-if="filter.includes('P') === true">
          <template v-if="unitName == 'grid'">
            <template v-if="'internal' in unitState">
              <AdvancedCore :name="$t('advanced.' + unitName + '.internal.p1')" :value="unitState.internal.p1" unit="kW" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.internal.p2')" :value="unitState.internal.p2" unit="kW" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.internal.p3')" :value="unitState.internal.p3" unit="kW" :widthRatio="width"></AdvancedCore>
            </template>
            <AdvancedCore :name="$t('advanced.' + unitName + '.power')" :value="unitState.power" unit="kW" :widthRatio="width"></AdvancedCore>
            <template v-if="'internal' in unitState">
              <AdvancedCore :name="$t('advanced.' + unitName + '.internal.q1')" :value="unitState.internal.q1" unit="kVAr" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.internal.q2')" :value="unitState.internal.q3" unit="kVAr" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.internal.q3')" :value="unitState.internal.q3" unit="kVAr" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.internal.s1')" :value="unitState.internal.s1" unit="kVA" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.internal.s2')" :value="unitState.internal.s3" unit="kVA" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.internal.s3')" :value="unitState.internal.s3" unit="kVA" :widthRatio="width"></AdvancedCore>
            </template>
          </template>
        </template>

        <template v-if="filter.includes('UI') === true">
          <template v-if="unitName == 'grid'">
            <template v-if="'external' in unitState">
              <AdvancedCore :name="$t('advanced.' + unitName + '.external.u1')" :value="unitState.external.u1" unit="V" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.external.u2')" :value="unitState.external.u2" unit="V" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.external.u3')" :value="unitState.external.u3" unit="V" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.external.i1')" :value="unitState.external.i1" unit="A" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.external.i2')" :value="unitState.external.i2" unit="A" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.external.i3')" :value="unitState.external.i3" unit="A" :widthRatio="width"></AdvancedCore>
            </template>
          </template>
        </template>

        <template v-if="filter.includes('P') === true">
          <template v-if="unitName == 'grid'">
            <template v-if="'external' in unitState">
              <AdvancedCore :name="$t('advanced.' + unitName + '.external.p1')" :value="unitState.external.p1" unit="kW" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.external.p2')" :value="unitState.external.p2" unit="kW" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.external.p3')" :value="unitState.external.p3" unit="kW" :widthRatio="width"></AdvancedCore>
              <!--               
              <AdvancedCore :name="$t('advanced.' + unitName + '.external.q1')" :value="unitState.external.q1" unit="kVAr" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.external.q2')" :value="unitState.external.q3" unit="kVAr" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.external.q3')" :value="unitState.external.q3" unit="kVAr" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.external.s1')" :value="unitState.external.s1" unit="kVA" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.external.s2')" :value="unitState.external.s3" unit="kVA" :widthRatio="width"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.' + unitName + '.external.s3')" :value="unitState.external.s3" unit="kVA" :widthRatio="width"></AdvancedCore> 
            -->
            </template>
          </template>
        </template>

        <template v-if="filter.includes('UI') === true">
          <template v-if="unitName == 'pv' || unitName == 'mppt'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.uOut')" :value="unitState.uOut" unit="V" :widthRatio="width"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.iOut')" :value="unitState.iOut" unit="A" :widthRatio="width"></AdvancedCore>
          </template>
        </template>
        <template v-if="unitName == 'pv' || unitName == 'mppt'">
          <template v-if="filter.includes('P') === true">
            <AdvancedCore :name="$t('advanced.' + unitName + '.powerOut')" :value="unitState.powerOut" unit="kW" :widthRatio="width"></AdvancedCore>
          </template>
          <template v-if="filter.includes('E') === true">
            <AdvancedCore :name="$t('advanced.' + unitName + '.energyOut')" :value="unitState.energyOut" unit="kWh" :widthRatio="width"></AdvancedCore>
          </template>
        </template>
        <template v-if="filter.includes('OTHERS') === true">
          <template v-if="unitName == 'load' || unitName == 'mppt'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.energyToday')" :value="unitState.energyToday" unit="kWh"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.energyYesterday')" :value="unitState.energyYesterday" unit="kWh"></AdvancedCore>
          </template>

          <template v-if="unitName == 'grid'">
            <AdvancedCore :name="$t('advanced.' + unitName + '.energyConsumptionToday')" :value="unitState.energyConsumptionToday" unit="kWh"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.energyConsumptionYesterday')" :value="unitState.energyConsumptionYesterday" unit="kWh"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.energyOverflowsToday')" :value="unitState.energyOverflowsToday" unit="kWh"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.' + unitName + '.energyOverflowsYesterday')" :value="unitState.energyOverflowsYesterday" unit="kWh"></AdvancedCore>
          </template>
        </template>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import AdvancedCore from "./AdvancedCore.vue";

export default {
  name: "AdvancedInOutPower",
  components: {
    AdvancedCore,
  },
  props: {
    unitState: {
      type: Object,
      require: false,
    },
    unitName: {
      type: String,
      require: true,
    },
    showHeader: {
      type: Boolean,
      required: false,
      default: false,
    },
    filter: {
      type: Array,
      required: false,
      default: () => ["UI", "P", "E", "OTHERS"],
    },
    width: {
      type: Number,
      require: false,
      default: 50,
    },
    data() {
      return {};
    },
  },
};
</script>
